<template>
    <div class="auth-bg">
        <div class="boxLoading">
            <span class="loading-title">
                加载中...
            </span>
            
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            code:"",
            plateNo:"",
            openId:""
        }
    },
    mounted(){
        let params = this.getQueryParams()
        if(params.code){
            this.code = params.code
        }
        if(params.plateNo){
            this.plateNo = params.plateNo
        }
        // if(this.$route.query.plateNo){
        //     this.plateNo = this.$route.query.plateNo
        //     // this.getPet()
        // }
        // let url = "http://192.168.0.104:8080/#" + (this.plateNo ? "/apply?plateNo="+this.plateNo : '/personCenter')
        // let userData = {
        //     userId:"320522199909099999",
        //     openId:"eveddsv123wefsf213eq123qwers",
        //     name:"阿斯蒂",
        //     phone:"13913766222",
        //     address:"太仓市"
        // }
        // sessionStorage.setItem("TC_PET_USERDATA",JSON.stringify(userData))
        // if(!this.plateNo){
        //     window.location.href = url
        // }
        let flag = sessionStorage.getItem("TC_PET_USERDATA")
        if(!flag){
            this.getUserInfo()
        }else{
            this.$router.push({path:"/personCenter"})
        }
    },
    methods:{
        getQueryParams() {
            var search = window.location.search;
            var queryParams = {};
            if (search) {
                search = search.substring(1); // 去掉问号
                var params = search.split('&');
                for (var i = 0; i < params.length; i++) {
                var pair = params[i].split('=');
                var paramName = decodeURIComponent(pair[0]);
                var paramValue = decodeURIComponent(pair[1]);
                queryParams[paramName] = paramValue;
                }
            }
            return queryParams;
        },
        getPet(){
            this.$post("/pet/web/selectBindingByPlateNo",{
                plateNo:this.plateNo,
                openId:this.openId
            }).then(res=>{
                if(res.data.code == 200){
                    if(res.data.data.flag){
                        this.$router.push({path:"/petDetail",query:{pet:JSON.stringify(res.data.data)}})
                    }else{
                        const ipAddress = window.location.href
                        const urlObject = new URL(ipAddress)
                        window.location.href = urlObject.origin + "/apply?plateNo="+this.plateNo
                    }
                }else{
                    this.$tip(res.msg)
                }
            })
        },
        getUserInfo(){
            const ipAddress = window.location.href
            const urlObject = new URL(ipAddress)
            let url = urlObject.origin + (this.plateNo ? "/apply?plateNo="+this.plateNo : '/personCenter')
            let sendUrl = this.plateNo?urlObject.origin+"?plateNo="+this.plateNo:urlObject.origin
            this.$post("/pet/web/wx/userinfo",{
                code:this.code,
                redirectUri:sendUrl
            }).then(res=>{
                if(res.status == 200){
                    if(res.data.code  == 200){
                        let userData = {
                            userId:res.data.data.userAuth?res.data.data.userAuth.cardId:"",
                            openId:res.data.data.id,
                            name:res.data.data.userAuth?res.data.data.userAuth.realName:"",
                            phone:res.data.data.phone,
                            photoUrl:res.data.data.photoUrl,
                            address:""
                        }
                        this.openId = res.data.data.id
                        sessionStorage.setItem("TC_PET_USERDATA",JSON.stringify(userData))
                        if(!this.plateNo){
                            window.location.href = url
                        }else{
                            this.getPet()
                        }
                    }else{
                        this.$tip(res.msg)
                    }
                }
            })
        }
    }
}
</script>
<style scoped>



.auth-bg{
    width:100%;
    height: 100vh;
    background: #000;
}
.loading-title{
    width:100px;
    position: absolute;
    top:80px;
    font-size: 14px;
    color:#fff;
}
/* loading.css */
.boxLoading {  
  width: 50px;
  height: 50px;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.boxLoading:before {
  content: '';
  width: 50px;
  height: 5px;
  background: #fff;
  opacity: 0.7;
  position: absolute;
  top: 59px;
  left: 0;
  border-radius: 50%;
  animation: shadow .5s linear infinite;
}
.boxLoading:after {
  content: '';
  width: 50px;
  height: 50px;
  background: #e04960;
  animation: animate .5s linear infinite;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 3px;
}
@keyframes animate {
  17% {
    border-bottom-right-radius: 3px;
  }
  25% {
    transform: translateY(9px) rotate(22.5deg);
  }
  50% {
    transform: translateY(18px) scale(1, .9) rotate(45deg);
    border-bottom-right-radius: 40px;
  }
  75% {
    transform: translateY(9px) rotate(67.5deg);
  }
  100% {
    transform: translateY(0) rotate(90deg);
  }
}
@keyframes shadow {
  0%, 100% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.2, 1);
  }
}
</style>